import { render, staticRenderFns } from "./CodigoAutenticacao.vue?vue&type=template&id=6a623b25&scoped=true"
import script from "./CodigoAutenticacao.vue?vue&type=script&lang=js"
export * from "./CodigoAutenticacao.vue?vue&type=script&lang=js"
import style0 from "./CodigoAutenticacao.vue?vue&type=style&index=0&id=6a623b25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a623b25",
  null
  
)

export default component.exports